import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { debounce } from '@ember/runloop';
import Component from '@glimmer/component';

import $ from 'jquery';

import didInsert from 'webapp/modifiers/did-insert';
import didUpdate from 'webapp/modifiers/did-update';
import willDestroy from 'webapp/modifiers/will-destroy';

// import { afterImagesLoaded } from 'webapp/utils/common';
// import { afterImagesLoaded } from 'webapp/utils/common';
import type ReportSlideFragment from 'webapp/models-custom/report-slide-fragment';

export interface Args {
	model?: ReportSlideFragment | null;
	onEdit?: () => void;
}

interface ReportsViewerImageCtComponentInterface<T> {
	Args: T;
	Blocks: { default: [] };
}

export default class ReportsViewerImageCtComponent extends Component<
	ReportsViewerImageCtComponentInterface<Args>
> {
	resizeFn: () => void = () => {
		/* */
	};

	@action
	editImage() {
		if (this.args.onEdit) {
			this.args.onEdit();
		}
	}

	@action
	setupView(node: HTMLElement) {
		const resizeFn = () => {
			debounce(this, this.setMaxWidth, node, 100);
		};
		this.resizeFn = resizeFn;

		resizeFn();

		$(window).on('resize.datawallcenter', this.resizeFn);
	}

	@action
	teardownView() {
		$(window).off('resize.datawallcenter', this.resizeFn);
	}

	private setMaxWidth(_node: HTMLElement) {
		// console.log('set max width');
		// const imageUrl = this.args.model?.primaryValue;
		// const imageNode = node.querySelector('img') as HTMLImageElement;
		// if (!imageNode) {
		// 	return;
		// }
		// if (imageUrl && this.args.model?.isImageProportionalToSlide) {
		// 	afterImagesLoaded([imageUrl]).then((settledPromises) => {
		// 		let maxWidthString = '100%';
		// 		const promise = settledPromises[0];
		// 		if (promise.status !== 'rejected') {
		// 			const image = promise.value?.image,
		// 				propotionBase = 1920, // width for snapshot
		// 				spaceTaken = Math.min(1, image.naturalWidth / propotionBase),
		// 				slideWidth = node.offsetWidth,
		// 				maxWidth = slideWidth * spaceTaken || 'auto';
		// 			maxWidthString = `${maxWidth}px`;
		// 		}
		// 		imageNode.style.maxWidth = maxWidthString;
		// 	});
		// } else {
		// 	imageNode.style.maxWidth = '100%';
		// }
	}
	<template>
		<div
			class="image-ct {{unless @model.isImageShown 'empty'}}"
			{{didInsert this.setupView}}
			{{didUpdate this.resizeFn @model.primaryValue}}
			{{willDestroy this.teardownView}}
		>
			{{#if @model.isImageShown}}
				<div class="image">
					<div
						role="button"
						class="image-inner {{if @onEdit 'editable'}}"
						{{on "click" this.editImage}}
					>
						<img src={{@model.primaryValue}} alt />
					</div>
				</div>
			{{else}}
				{{yield}}
			{{/if}}
		</div>
	</template>
}
